"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var react_1 = __importDefault(require("react"));
var react_router_1 = require("react-router");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var TextButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TextButton"));
var StepProgress_1 = __importDefault(require("./StepProgress"));
var StyledWrapper = (0, styles_1.styled)('div')(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            background: theme.palette.common.white
        },
        _b[theme.breakpoints.down('lg')] = {
            width: '100%',
        },
        _b);
});
var makeOnboardingFooter = function (WizardContext, options) { return function (_a) {
    var onSkipClick = _a.onSkipClick, isNextDisabled = _a.isNextDisabled, onBeforeNext = _a.onBeforeNext, trackMappedState = _a.trackMappedState;
    var _b = react_1.default.useContext(WizardContext), onNextClick = _b.onNextClick, onPrevClick = _b.onPrevClick, stepNumber = _b.stepNumber, totalSteps = _b.totalSteps, onEnd = _b.onEnd, currentStep = _b.currentStep, blockBackFromFirst = _b.blockBackFromFirst;
    var _c = __read(react_1.default.useState(false), 2), loading = _c[0], setLoading = _c[1];
    var history = (0, react_router_1.useHistory)();
    var metaProgress = (100 / totalSteps) / 2;
    var progress = ((stepNumber - 1) / totalSteps) * 100 + metaProgress;
    var handlePreviousClick = function () {
        if (stepNumber === 1) {
            history.push('/dashboard');
        }
        else if (onPrevClick) {
            onPrevClick();
        }
    };
    var onClickNext = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    if (!onBeforeNext) return [3 /*break*/, 2];
                    return [4 /*yield*/, onBeforeNext()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    trackMappedState();
                    if (!(stepNumber === totalSteps)) return [3 /*break*/, 4];
                    // In the last step, wait for onEnd
                    return [4 /*yield*/, onEnd(currentStep)];
                case 3:
                    // In the last step, wait for onEnd
                    _a.sent();
                    _a.label = 4;
                case 4: return [4 /*yield*/, onNextClick()];
                case 5:
                    _a.sent();
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var hideGoBackButton = blockBackFromFirst && stepNumber === 1;
    return ((0, jsx_runtime_1.jsxs)(StyledWrapper, { children: [(0, jsx_runtime_1.jsx)(StepProgress_1.default, { progress: progress }), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", justifyContent: "space-between", alignItems: "center", pl: 2, pr: 4, py: 2 }, { children: [(0, jsx_runtime_1.jsx)(TextButton_1.default, __assign({ color: "neutral", onClick: handlePreviousClick, disabled: hideGoBackButton, sx: { visibility: hideGoBackButton ? 'hidden' : 'visible' } }, { children: "Go back" })), (0, jsx_runtime_1.jsxs)("div", { children: [onSkipClick && ((0, jsx_runtime_1.jsx)(TextButton_1.default, __assign({ color: "neutral", onClick: onSkipClick, sx: { mr: 2 } }, { children: "Skip for now" }))), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ size: "large", isSending: loading, type: "submit", disabled: isNextDisabled, onClick: onClickNext }, { children: stepNumber === totalSteps ? (options === null || options === void 0 ? void 0 : options.finishButtonText) || 'Finish' : 'Next' }))] })] }))] }));
}; };
exports.default = makeOnboardingFooter;
